import React from 'react';
import { IoStatsChartOutline } from 'react-icons/io5';

import './StatsCard.scss';

/**
 * Renders a React component that displays a stat metric. This component is composed of a header section
 * that shows the image and metric, and a title section that displays the metric name.
 *
 * @param {string} className - The CSS class name for the stats card.
 * @param {string} imageUrl  - Url for the image that will show next to the count.
 * @param {string} title     - The stats title showed at the bottom of the component.
 * @param {number} count     - Number that represents a metric related with the title.
 * @returns {JSX.Element}    - The rendered stats card component.
 */
function StatsCard({
  className, imageUrl, title, count,
}: { className?:string, imageUrl: string, title: string, count: number }): JSX.Element {
  return (
    <div className={`stats-card ${className}`}>
      <div className="stats-header">
        <div className="stats-image">
          { imageUrl
            ? <img src={imageUrl} alt="stats" />
            : <IoStatsChartOutline size={60} color="var(--pgn-color-secondary-200)" />}
        </div>
        <div className="stats-count">
          {`+${count}`}
        </div>
      </div>
      <div className="stats-title">
        {title}
      </div>
    </div>
  );
}

StatsCard.defaultProps = {
  className: '',
};

export default StatsCard;
